export default Object.freeze({
  PENDING: 'pending',
  ACCEPTED: 'accepted',
  REFUSED: 'refused',
  LIVE: 'live',
  DOCUMENT: 'document',
  SCREEN_SHARING: 'screenSharing'
})
